import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { LocalStorage } from '../../../services';
import { _post, _SERVER_URL_ } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const MarketingCodesList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('marketing_codes'), link: '/marketing-codes-list' },
		{ title: t('list') }
	];

	const [marketingCodes, setMarketingCodes] = useState([]);
	let marketingCodesListData = {
		head: [t('code'), t('users'), t('status'), t('operation')],
		body: marketingCodes.map(marketingCode => [
			marketingCode.code_name,
			<>
				{marketingCode.user_data.map(user =>
					<div>
						<Link className='' to={`/users-edit/${user.user_id}`} target="_blank">
							{user.user_fullname} - {user.national_code} - {user.code.commission}%
						</Link>
					</div>
				)}
			</>,
			<span className={"badge rounded-pill p-2 badge-subtle-" + (marketingCode.is_active ? 'success' : 'secondary')}>
				{marketingCode.is_active ? t('active') : t('deactive')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/marketing-codes-edit/${marketingCode.code_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['rtl', 'rtl', '', 'ltr']
	};

	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchMarketingCodeTitle, setSearchMarketingCodeTitle] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getMarketingCodes = async () => {
		let body = {
			code_name: searchMarketingCodeTitle,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/codes/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_codes);
				setMarketingCodes(response.data.codes);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterMarketingCodes = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchMarketingCodeTitle.value.trim() || null;
		setSearchMarketingCodeTitle(title);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};
	
	const getMarketingCodesExcel = async event => {
		event.preventDefault();
		let token = LocalStorage.get('token');
		let getMarketingCodesExcelLink = `${_SERVER_URL_}/download-excel-marketers?token=${token}`;
		window.open(getMarketingCodesExcelLink, "_blank", "noreferrer");
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getMarketingCodes();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('marketing_codes')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterMarketingCodes}>
						<div className="row gx-2">
							<FormField fieldKey="searchMarketingCodeTitle" title={t('code')} value={searchMarketingCodeTitle} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('marketing_codes')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={marketingCodesListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('get_excel')} {t('marketing_codes')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={getMarketingCodesExcel}>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create">
								<i className="fa fa-download"></i> {t('get_excel')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default MarketingCodesList;
